export const eduSystemG = [
  {
    name: "Select",
    value: "",
  },
  {
    name: "High School",
    value: "High School",
  },
  {
    name: "Bachelor Degree",
    value: "Bachelor Degree",
  },

  {
    name: "Master Degree",
    value: "Master Degree",
  },
  {
    name: "PhD",
    value: "PhD",
  },
];
